<template>
  <div class="bg">
    <div class="body">
      <h1 class="mod-title">
        <span class="ico_log ico-3"></span>
      </h1>

      <div class="mod-ct">
        <div class="order"></div>
        <div class="amount" id="money">
          <span style="font-size: 30px">￥</span> {{ order.price }}
        </div>
        <div class="qrcode-img-wrapper" data-role="qrPayImgWrapper">
          <div data-role="qrPayImg" class="qrcode-img-area">
            <div style="position: relative; display: inline-block">
              <img v-lazy="base_img" style="display: block; width: 210px" />
            </div>
          </div>
        </div>

        <div class="tip">
          <van-button
            type="primary"
            class="tip-btn2"
            :loading="loading"
            :loading-text="loadingText"
            v-if="mweb"
            @click="query"
            >查询订单结果</van-button
          ><van-button
            type="primary"
            class="tip-btn2"
            v-else-if="jsapi"
            @click="jsApiCall"
            >点击支付</van-button
          >
          <div v-else>
            <div class="ico-scan3"></div>
            <div class="tip-text">
              <p>请使用微信扫一扫</p>
              <p>扫描二维码完成支付</p>
            </div>
          </div>
        </div>

        <div class="detail" :class="open ? 'detail-open' : ''">
          <dl class="detail-ct" :style="open ? 'height: 130px' : ''">
            <dt>商品名称</dt>
            <dd>{{ order.goods_name }}</dd>
            <dt>商户单号</dt>
            <dd>{{ order.out_trade_no }}</dd>
            <dt>金额</dt>
            <dd>￥{{ order.price }}</dd>
            <dt>创建时间</dt>
            <dd>{{ order.addTime }}</dd>
          </dl>
          <a href="javascript:void(0)" class="arrow" @click="open = !open"
            ><i class="ico-arrow3"></i
          ></a>
        </div>

        <div class="tip-text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { postPay, getOrder, getStatus } from "@/api/index";
import QRCode from "qrcodejs2";
import { Toast } from "vant";
import { mapState } from "vuex";
export default {
  data() {
    return {
      open: false,
      mweb: false,
      jsapi: false,
      loading: false,
      loadingText: "正在查询...",
      out_trade_no: "",
      order: {},
      code_url: "",
      base_img: "",
      jsParames: {},
    };
  },
  computed: {
    ...mapState(["isMobile"]),
  },
  created() {
    this.out_trade_no = this.$route.params.out_trade_no;
    this._getOrder(this.$route.params.out_trade_no);
    this._postPay(this.$route.params.out_trade_no);
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timers = setInterval(() => {
      _this._getStatus(_this.out_trade_no);
    }, 3000);
  },

  methods: {
    // 提交支付
    _postPay(out_trade_no) {
      postPay({
        out_trade_no: out_trade_no,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data.trade_type == "NATIVE") {
            this.code_url = res.data;
            this.base_img = res.data.base_img;
          }
          if (res.data.trade_type == "MWEB") {
            this.base_img = require("@/assets/img/wx_icon.png");
            this.mweb = true;
            this.goMwebUrl(res.data.mweb_url);
          }
          if (res.data.trade_type == "JSAPI") {
            this.base_img = require("@/assets/img/wx_icon.png");
            this.jsParames = res.data.parames;
            this.jsapi = true;
            this.jsApiCall();
          }

          //  生成二维码
          // let qrcode = new QRCode("qrcode", {
          //   width: 230,
          //   height: 230, // 高度
          //   text: res.data, // 二维码内容
          //   colorDark: "#000000", //前景色
          //   colorLight: "#ffffff", //背景色
          //   correctLevel: QRCode.CorrectLevel.L, //容错等级
          // });
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },

    goMwebUrl(url) {
      var a = document.createElement("a");
      a.setAttribute("href", url);
      document.body.appendChild(a);
      a.style.display = "none";
      a.click();
    },

    //调用微信JS api 支付
    jsApiCall() {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        this.jsParames,
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this._getStatus(this.out_trade_no);
          }
        }
      );
    },
    // 查询订单
    _getOrder(out_trade_no) {
      getOrder({
        out_trade_no,
      }).then((res) => {
        if (res.code == 200) {
          this.order = res.data;
          this.open = true;
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },

    // 查询状态
    _getStatus(out_trade_no) {
      getStatus({
        out_trade_no: out_trade_no,
      }).then((res) => {
        if (res.data) {
          clearInterval(this.timers);
          if (this.isMobile) {
            this.$router.push("/m/query");
          } else {
            this.$router.push("/query");
          }
        }
      });
    },

    // 手动查询订单结果
    query() {
      this.loading = true;
      getStatus({
        out_trade_no: this.out_trade_no,
      }).then((res) => {
        this.loading = false;
        if (res.data) {
          clearInterval(this.timers);
          Toast({
            message: "支付成功，正在跳转...",
            position: "bottom",
          });
          if (this.isMobile) {
            this.$router.push("/m/query");
          } else {
            this.$router.push("/query");
          }
        } else {
          Toast({
            message: "未完成支付",
            position: "bottom",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
@import url("../../../assets/css/pay.css");
</style>